/*
  Revenant Edge: on phones, product cards open on the back print and flip
  to the front every few seconds. Desktop is untouched (hover still shows
  the back). The product page is untouched.

  A card stops flipping for good once the shopper touches it, so swiping
  and the size picker never fight the timer.
*/
(() => {
  const mobile = matchMedia('(max-width: 749px)');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const INTERVAL_MS = 2500;
  const BACK = 1;
  const FRONT = 0;

  const timers = new Map();
  const touched = new WeakSet();

  const cardSlideshows = (root = document) =>
    root.querySelectorAll('.card-gallery slideshow-component');

  const slideCount = (slideshow) => slideshow.slides?.length || 0;

  const show = (slideshow, index, animate) => {
    try {
      slideshow.select(index, undefined, { animate });
    } catch (error) {
      // The slideshow has not finished initializing yet; the next tick retries.
    }
  };

  const stop = (slideshow) => {
    clearInterval(timers.get(slideshow));
    timers.delete(slideshow);
  };

  const start = (slideshow) => {
    if (!mobile.matches || touched.has(slideshow) || timers.has(slideshow)) return;
    if (typeof slideshow.select !== 'function' || slideCount(slideshow) < 2) return;

    show(slideshow, BACK, false);
    if (reducedMotion.matches) return;

    timers.set(
      slideshow,
      setInterval(() => {
        show(slideshow, slideshow.current === BACK ? FRONT : BACK, true);
      }, INTERVAL_MS)
    );
  };

  const visibility = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) start(entry.target);
        else stop(entry.target);
      }
    },
    { threshold: 0.5 }
  );

  const watch = (slideshow) => {
    if (slideshow.dataset.revenantFlip) return;
    slideshow.dataset.revenantFlip = 'on';
    visibility.observe(slideshow);
    const handOver = () => {
      touched.add(slideshow);
      stop(slideshow);
    };
    slideshow.closest('.card-gallery')?.addEventListener('pointerdown', handOver, { passive: true });
  };

  const watchAll = (root) => cardSlideshows(root).forEach(watch);

  customElements.whenDefined('slideshow-component').then(() => {
    watchAll(document);

    // Collection filtering, sorting and "load more" add new cards.
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element) watchAll(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    mobile.addEventListener('change', () => {
      for (const slideshow of timers.keys()) stop(slideshow);
      if (!mobile.matches) cardSlideshows().forEach((slideshow) => show(slideshow, FRONT, false));
    });
  });
})();
